<hub-sub-menu></hub-sub-menu>
<ul class="hubcomms">
  <li>
    <button class="secret" (click)="later()"><span class="created center">Newer</span></button>
    <span class="api center">API</span>
    <span class="char">By</span>
    <span class="comms_type">Type</span>
    <span class="ip center">IP</span>
  </li>
  <ng-container *ngIf="!!hubcomms; else loading">
    <li *ngFor="let comms of hubcomms">
      <span class="created">{{comms.created | godate}}</span>
      <span class="api">{{comms.api}}</span>
      <span class="char">{{comms.initiatorid}}</span>
      <span class="comms_type">{{comms.typeid | commsType}}</span>
      <span class="ip">{{comms.ip}}</span>
      <span class="toggles">
        <button *ngIf="comms.headers" (click)="showHeaders(comms.uid)">Show Headers</button>
        <button *ngIf="comms.body" (click)="showBody(comms.uid)">Show Body</button>
        <button *ngIf="comms.payload" (click)="showRawPayload(comms.uid)">Show Raw Payload</button>
      </span>
      <ul class="headers" *ngIf="headersVisible === comms.uid">
        <li *ngFor="let hdr of comms.headers"><span class="hdr_key">{{hdr.key}}</span><span class="hdr_value">{{hdr.value}}</span></li>
      </ul>
      <div class="body" *ngIf="bodyVisible === comms.uid">
        <div [ngSwitch]="comms.api" class="payload">
          <div *ngSwitchCase="'/api/hubschedule'" class="schedule-payload"><schedule-payload [payload]="comms.body"></schedule-payload></div>
          <div *ngSwitchCase="'/hub/hubschedule'" class="schedule-payload"><schedule-payload [payload]="comms.body"></schedule-payload></div>
          <div *ngSwitchCase="'/phone/getevents'" class="schedule-payload"><schedule-payload [payload]="comms.body"></schedule-payload></div>
          <div *ngSwitchCase="'/phone/getsnapshot'" class="snapshot-payload"><snapshot-payload [payload]="comms.body"></snapshot-payload></div>
          <div *ngSwitchCase="'/phone/getstatus'" class="snapshot-payload">
            <div *ngIf="!!comms.body.pending">App changes are queued for poll from Hub...</div>
            <snapshot-payload [payload]="comms.body.snapshot"></snapshot-payload>
          </div>
          <div *ngSwitchCase="'/phone/gethubs'" class="gethubs-payload"><gethubs-payload [payload]="comms.body"></gethubs-payload></div>
          <div *ngSwitchCase="'/hub/checkfirmwareversion'" class="payload"><checkfirmwareversion-payload [payload]="comms.body"></checkfirmwareversion-payload></div>
          <div *ngSwitchCase="'/api/checkfirmwareversion'" class="payload"><checkfirmwareversion-payload [payload]="comms.body"></checkfirmwareversion-payload></div>
          <div *ngSwitchCase="'/api/history'" class="payload"><history-payload [payload]="comms.body"></history-payload></div>
          <div *ngSwitchCase="'/phone/sendmeterimage'" class="default-payload">
            <ng-container *ngIf="comms.body.image; else response">Meter Image: {{comms.body.encoding}}, {{comms.body.image.length}} bytes encoded.</ng-container>
            <ng-template #response>{{Stringify(comms.body)}}</ng-template>
          </div>
          <div *ngSwitchCase="'/phone/checktoken'" class="payload">
            <div *ngIf="!!comms.typeid && comms.typeid == 50020" class="default-payload">Expiry: {{comms.body.expiry | unixdate}}</div>
          </div>
          <div *ngSwitchCase="'/phone/setheat'" class="default-payload">Set to: {{comms.body.setstate | heatingState}} at {{comms.body.setting}}°C</div>
          <div *ngSwitchDefault class="default-payload">{{Stringify(comms.body)}}</div>
        </div>
      </div>
      <div class="payload" *ngIf="payloadVisible === comms.uid">
        <pre>{{comms.payload}}</pre>
      </div>
    </li>
  </ng-container>
  <ng-template #loading>Fetching data...</ng-template>
  <li>
    <button class="secret" (click)="earlier()"><span class="created center">Older</span></button>
    <span class="api center">API</span>
    <span class="char">By</span>
    <span class="comms_type">Type</span>
    <span class="ip center">IP</span>
  </li>
</ul>
